import { request } from '@/fetch/core';
import { Method } from '@/fetch/core/util';

export default class RemoteCallApi {
  /**
   * 获取常用语列表
   * @return {Object} promise
   */
  public getWordList(): Promise<any> {
    const requestParams: RequestOptions = {
      path: '/monitor/web/rxc/word_list',
      method: Method.POST,
    };

    return request(requestParams);
  }

  /**
   * 新增常用语
   * @param {string} content 喊话内容
   * @return {Object} promise
   */
  public addWord(content: string): Promise<any> {
    const requestParams: RequestOptions = {
      path: '/monitor/web/rxc/add',
      method: Method.POST,
      body: {
        content: content,
      },
    };

    return request(requestParams);
  }

  /**
   * 删除常用语
   * @param {number} id 常用语id
   * @return {Object} promise
   */
  public deleteWord(id: number): Promise<any> {
    const requestParams: RequestOptions = {
      path: '/monitor/web/rxc/delete',
      method: Method.POST,
      body: {
        id: id,
      },
    };

    return request(requestParams);
  }

  /**
   *  下发远程喊话指令
   * @param {Object} param
   * @return {Object} promise
   */
  public sendRemoteCall(param: {
    vehicleName: string;
    message: string;
  }): Promise<any> {
    const requestParams: RequestOptions = {
      path: '/schedule/api/mini-monitor/remote-business-command',
      method: Method.POST,
      body: {
        ...param,
        remoteBusinessCommand: 'TALK',
      },
    };

    return request(requestParams);
  }
}
